import { SponsorshipEmailFields } from "~/types/account/account.types";

import { sendRequest } from "../clients/axios";

export const sendSponsorEmail = async (input: SponsorshipEmailFields) => {
  const res = await sendRequest<SponsorshipEmailFields, any>({
    method: "post",
    url: "/user/send-sponsor-code-email",
    data: input,
  });
  return res.data;
};
